<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" :lg="6" class="d-flex ga-2 align-center justify-start">
      <v-menu transition="scale-transition">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="main-color-btn cursor-pointer" :disabled="!$permissionsFor('my-drive').create"
            :class="{ 'read-only': !$permissionsFor('my-drive').create }">
            <div class="d-flex align-center ga-2">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="16" height="16" rx="8" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.99999 2C8.4142 2 8.74999 2.33579 8.74999 2.75V7.25H13.25C13.6642 7.25 14 7.58579 14 8C14 8.41422 13.6642 8.75 13.25 8.75H8.74999V13.25C8.74999 13.6642 8.4142 14 7.99999 14C7.58578 14 7.24999 13.6642 7.24999 13.25V8.75H2.75C2.33579 8.75 2 8.41422 2 8C2 7.58579 2.33579 7.25 2.75 7.25H7.24999V2.75C7.24999 2.33579 7.58578 2 7.99999 2Z"
                  fill="#237276" />
              </svg>
              <span>{{ $t("new") }}</span>
            </div>
          </span>
        </template>
        <v-list>
          <v-list-item class="select-option">
            <v-list-item-title @click="$emit('open:NewFolder', true)">
              {{ $t("folder") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="select-option">
            <v-list-item-title @click="$emit('open:NewImage', true)">
              {{ $t("image") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="select-option">
            <v-list-item-title @click="$emit('open:NewVideo', true)">
              {{ $t("video") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <Input v-model="search" type="search" :icon="SearchIcon" :placeholder="$t('search_here')" />
      <button @click="handleInput" class="cancel-btn" style="width: auto">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14.9881 4.52007C11.673 4.14956 8.32686 4.14956 5.01172 4.52007C4.78742 4.54514 4.6794 4.80819 4.82135 4.98366L7.7522 8.60662C8.80211 9.90447 9.37491 11.5233 9.37491 13.1926V15.6003L10.6249 16.517V13.1926C10.6249 11.5233 11.1977 9.90446 12.2476 8.60662L15.1785 4.98366C15.3204 4.80819 15.2124 4.54514 14.9881 4.52007ZM4.87288 3.27781C8.2803 2.89698 11.7195 2.89698 15.1269 3.27781C16.3327 3.41257 16.9134 4.82656 16.1503 5.76983L13.2194 9.39279C12.3495 10.4681 11.8749 11.8094 11.8749 13.1926V17.7503C11.8749 17.9859 11.7425 18.2014 11.5324 18.3079C11.3223 18.4143 11.0702 18.3936 10.8803 18.2543L8.38031 16.421C8.21976 16.3033 8.12491 16.1161 8.12491 15.917V13.1926C8.12491 11.8094 7.65031 10.4682 6.78038 9.39279L3.84953 5.76983C3.08646 4.82656 3.66711 3.41257 4.87288 3.27781Z"
            fill="#666666" />
        </svg>
      </button>
    </v-col>
    <v-col cols="12" :lg="6" class="d-flex ga-2 align-center justify-end">
      <v-menu transition="scale-transition">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="dropdown-button">
            <span>{{ sortBy ? $t(sortBy.title) : $t("show_all") }}</span>
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 3L5 7L9 3" stroke="#666666" stroke-width="1.6" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </template>
        <v-list>
          <v-list-item class="select-option" v-for="(item, i) in sortBysItems" :key="i">
            <v-list-item-title @click="selectSortBy(item)">{{
              $t(item.title)
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="">
        <div class="list-type">
          <div @click="comp_view_type = 'list'" :class="[
            'list cursor-pointer',
            comp_view_type === 'list' ? 'active' : '',
          ]">
            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19.5938 4H7.31719C7.00781 4 6.75469 4.27618 6.75469 4.61374V7.54435C6.75469 7.88191 7.00781 8.15809 7.31719 8.15809H19.5938C19.9031 8.15809 20.1562 7.88191 20.1562 7.54435V4.61374C20.1562 4.27618 19.9031 4 19.5938 4ZM19.0312 6.93061H7.87969V5.22748H19.0312V6.93061ZM4.06172 4C3.01055 4 2.15625 4.93212 2.15625 6.07905C2.15625 7.22597 3.01055 8.15809 4.06172 8.15809C5.11289 8.15809 5.96719 7.22597 5.96719 6.07905C5.96719 4.93212 5.11289 4 4.06172 4ZM4.06172 6.93061C3.63281 6.93061 3.28125 6.54702 3.28125 6.07905C3.28125 5.61107 3.63281 5.22748 4.06172 5.22748C4.49062 5.22748 4.84219 5.61107 4.84219 6.07905C4.84219 6.55086 4.49062 6.93061 4.06172 6.93061ZM4.06172 10.1144C3.01055 10.1144 2.15625 11.0465 2.15625 12.1934C2.15625 13.3404 3.01055 14.2725 4.06172 14.2725C5.11289 14.2725 5.96719 13.3404 5.96719 12.1934C5.96719 11.0465 5.11289 10.1144 4.06172 10.1144ZM4.06172 13.045C3.63281 13.045 3.28125 12.6614 3.28125 12.1934C3.28125 11.7255 3.63281 11.3419 4.06172 11.3419C4.49062 11.3419 4.84219 11.7255 4.84219 12.1934C4.84219 12.6614 4.49062 13.045 4.06172 13.045ZM4.06172 16.2288C3.01055 16.2288 2.15625 17.1609 2.15625 18.3078C2.15625 19.4547 3.01055 20.3869 4.06172 20.3869C5.11289 20.3869 5.96719 19.4547 5.96719 18.3078C5.96719 17.1609 5.11289 16.2288 4.06172 16.2288ZM4.06172 19.1594C3.63281 19.1594 3.28125 18.7758 3.28125 18.3078C3.28125 17.8398 3.63281 17.4563 4.06172 17.4563C4.49062 17.4563 4.84219 17.8398 4.84219 18.3078C4.84219 18.7758 4.49062 19.1594 4.06172 19.1594ZM19.5938 10.1144H7.31719C7.00781 10.1144 6.75469 10.3906 6.75469 10.7281V13.6587C6.75469 13.9963 7.00781 14.2725 7.31719 14.2725H19.5938C19.9031 14.2725 20.1562 13.9963 20.1562 13.6587V10.7281C20.1562 10.3906 19.9031 10.1144 19.5938 10.1144ZM19.0312 13.045H7.87969V11.3419H19.0312V13.045ZM19.5938 16.2288H7.31719C7.00781 16.2288 6.75469 16.505 6.75469 16.8425V19.7731C6.75469 20.1107 7.00781 20.3869 7.31719 20.3869H19.5938C19.9031 20.3869 20.1562 20.1107 20.1562 19.7731V16.8425C20.1562 16.5011 19.9031 16.2288 19.5938 16.2288ZM19.0312 19.1594H7.87969V17.4563H19.0312V19.1594Z"
                :fill="comp_view_type === 'list' ? '#F2F2F2' : '#237276'" />
            </svg>
          </div>
          <div @click="comp_view_type = 'box'" :class="[
            'box cursor-pointer',
            comp_view_type === 'box' ? 'active' : '',
          ]">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4031_119775)">
                <path d="M12.5 7.65625H7.8125V12.3438H12.5V7.65625Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.5703 7.65625H14.8828V12.3438H19.5703V7.65625Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.42969 7.65625H0.742188V12.3438H5.42969V7.65625Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.5 14.7266H7.8125V19.4141H12.5V14.7266Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.5703 14.7266H14.8828V19.4141H19.5703V14.7266Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.42969 14.7266H0.742188V19.4141H5.42969V14.7266Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M12.5 0.585938H7.8125V5.27344H12.5V0.585938Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.5703 0.585938H14.8828V5.27344H19.5703V0.585938Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.42969 0.585938H0.742188V5.27344H5.42969V0.585938Z"
                  :stroke="comp_view_type === 'box' ? '#F2F2F2' : '#237276'" stroke-width="1.2" stroke-miterlimit="10"
                  stroke-linecap="round" stroke-linejoin="round" />
              </g>
              <defs>
                <clipPath id="clip0_4031_119775">
                  <rect width="20" height="20" fill="white" transform="translate(0.15625)" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import SearchIcon from "@/assets/images/icons/search.svg";
import Input from "@/components/crm/assets/Input.vue";
import { VDateInput } from "vuetify/labs/VDateInput";
import { DriveStore } from "@/store/drive/DriveStore";

export default {
  name: "DriveFilter",
  components: { Input, VDateInput },
  props: { view_type: String },
  data() {
    return {
      search: "",
      SearchIcon,
      sortBysItems: [
        { id: "all", title: "show_all" },
        { id: "folder", title: "folder" },
        { id: "image", title: "image" },
        { id: "video", title: "video" },
      ],
      start_date: null,
      end_date: null,
      sortBy: null,
      drawer: false,
      comp_view_type: this.view_type,
      store: DriveStore(),
      debounceTimeout: null,
    };
  },
  watch: {
    comp_view_type() {
      this.$emit("update:view_type", this.comp_view_type);
    },
    search() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.store.search_text = this.search;
        this.store?.getAllDrive();
      }, 500);
    },
  },
  mounted() {
    this.selectSortBy(this.sortBysItems[0]);
    this.store?.getAllDrive();
  },

  methods: {
    openNewFolder() {
      this.$emit("open:NewFolder", true);
    },
    handleInput() {
      this.store.search_text = this.search;
      this.store.getAllDrive();
    },
    selectSortBy(item) {
      this.sortBy = item;
      if (item.id === "all") {
        this.store.filter = null;
      } else {
        this.store.filter = item.id;
      }
      this.store.getAllDrive();
    },
  },
};
</script>
<style>
.custom-calender .v-input .v-input__control .v-field {
  width: 150px;
  height: 32px;
  border-radius: 8px;
  border: 1px;
  padding: 6px 8px 6px 8px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e6e6e6;
  color: #666666;
  box-shadow: unset;
}

.custom-calender .v-input .v-input__control .v-field__field .v-field__input {
  padding: 0px;
}
</style>
<style scoped>
.dropdown-button {
  width: 125px;
  height: 32px;
  border-radius: 8px;
  border: 1px;
  padding: 6px 8px 6px 8px;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e6e6e6;
  color: #666666;
}

.main-color-btn {
  height: 36px;
  padding: 5px 10px;
  border-radius: 8px;
  background: #237276 !important;
  color: #ffffff;
}

.btn-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-transform: capitalize;
}

.select-option {
  width: 172px;
  height: 32px;
  padding: 4px 8px 4px 8px;
  border-radius: 4px;
  color: #333333;
  background: #fafafa;
}

.select-option:hover {
  background: #eeeeee;
  color: #1f666a;
}

.list-type {
  width: 91.84px;
  height: 40px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
}

.list-type .list,
.list-type .box {
  width: 50%;
  height: 100%;
  background: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-type .list.active,
.list-type .box.active {
  background: #237276;
}
</style>
